import { Box, Flex, Center, Icon, Progress, Text } from '@chakra-ui/react';
import { HiDownload } from 'react-icons/hi';

export const DownloadReports = ({
  isPolling,
  pollingText = 'Your PDF is being prepared',
}) => {
  if (!isPolling) return null;

  return (
    <Box
      zIndex={99}
      position="fixed"
      bottom="24px"
      right="24px"
      p="12px 18px"
      boxShadow="0px 4px 4px rgba(0, 0, 0, 0.04)"
      borderRadius="10px"
      borderColor="border-color"
      borderWidth="1px"
      bg="#fff"
    >
      <Flex alignItems="center" gap="8px">
        <Center width="30px" height="30px" bg="ats-primary" borderRadius="full">
          <Icon as={HiDownload} width="20px" height="20px" color="white" />
        </Center>
        <Box flex="1" ml="8px">
          <Text size="md-semi-bold">{pollingText}</Text>
          <Box mt="12px">
            <Progress isIndeterminate size="xs" className="ats-progress-bar" />
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};
